/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { XdaStringsService } from './services/xda-strings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  constructor(
    public router: Router,
    private xdaStringsService: XdaStringsService,
    private renderer: Renderer2,
  ) {
    this.renderer.addClass(
      document.body,
      this.xdaStringsService.strings['UILANG'],
    );
  }
}
